import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RemoveIcon } from "@/components/Icons";
import type { PlayerDraft } from "@/hooks/usePlayersState";

interface FinalChipsRowProps {
  player: PlayerDraft;
  rowLabel: number;
  chipInputValue: (playerId: string, field: "chipsBought" | "finalChips", storedRawValue: string) => string;
  beginChipEdit: (playerId: string, field: "chipsBought" | "finalChips", currentRawValue: string) => void;
  changeChipEdit: (playerId: string, field: "chipsBought" | "finalChips", nextValue: string) => void;
  endChipEdit: (playerId: string, field: "chipsBought" | "finalChips") => void;
  hidePlayerFromFinalList: (id: string) => void;
}

export function FinalChipsRow({
  player,
  rowLabel,
  chipInputValue,
  beginChipEdit,
  changeChipEdit,
  endChipEdit,
  hidePlayerFromFinalList,
}: FinalChipsRowProps) {
  return (
    <div className="grid gap-2 grid-cols-[1.75rem_minmax(0,1fr)_4.75rem] md:grid-cols-[1.75rem_2fr_1fr] md:gap-3 items-center">
      <Button
        type="button"
        variant="outline"
        size="icon-sm"
        className="rounded-full"
        onClick={() => hidePlayerFromFinalList(player.id)}
        aria-label={`Remove ${player.name || `player ${rowLabel}`} from final chips list`}
        title="Remove from final chips list"
      >
        <RemoveIcon />
      </Button>

      <Label htmlFor={`player-final-label-${player.id}`} className="sr-only">
        Player {rowLabel}
      </Label>
      <Input
        id={`player-final-label-${player.id}`}
        value={player.name}
        readOnly
        className="h-8 px-2 text-xs md:h-9 md:px-3 md:text-sm"
      />

      <Label htmlFor={`finalchips-${player.id}`} className="sr-only">
        Player {rowLabel} final chips
      </Label>
      <Input
        id={`finalchips-${player.id}`}
        type="text"
        inputMode="numeric"
        value={chipInputValue(player.id, "finalChips", player.finalChips)}
        onFocus={() => beginChipEdit(player.id, "finalChips", player.finalChips)}
        onChange={(e) => changeChipEdit(player.id, "finalChips", e.target.value)}
        onBlur={() => endChipEdit(player.id, "finalChips")}
        placeholder="0"
        className="h-8 px-2 text-xs md:h-9 md:px-3 md:text-sm"
      />
    </div>
  );
}
